import { isValidNumber } from '@usas/ui-web/utils/validation';

export const localValidate = (formState) => {
  let errors = {};

  //Owner Type
  if (formState.clubOwnerTypeId < 0) {
    errors.clubOwnerTypeId = 'Owner Type is required'
  }

  //Tax Listing
  if (formState.businessEntityTypeId < 0) {
    errors.businessEntityTypeId = 'Tax Listing is required'
  }

  //Number of Board Members
  if (formState.isNumOfBoardMembersRequired === true) {
    if (formState.numOfBoardMembers === '') {
      errors.numOfBoardMembers = 'Number of Board Members is required for the selected Owner Type'
    } else if (!isValidNumber(Number(formState.numOfBoardMembers)) || Number(formState.numOfBoardMembers) > 15 || Number(formState.numOfBoardMembers) < 1 || !Number.isInteger(Number(formState.numOfBoardMembers))) {
      errors.numOfBoardMembers = 'Number of Board Members must be a whole number between 1 and 15'
    }
  }

  //LSC
  if (formState.lscId < 0) {
    errors.lscId = 'LSC is required'
  }

  if (formState.lscName === 'Usa Swimming') {
    errors.lscId = 'LSC is not valid'
  }

  //Offering Instance
  if (formState.offeringInstanceId < 0) {
    errors.offeringInstanceId = 'Offering Instance is required'
  }

  return errors;
};

const ClubRegistrationDisclaimerValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default ClubRegistrationDisclaimerValidation;